import { useState } from 'react';
import { LogOut, Moon, Sun, User } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import { storage } from '@/lib/storage';
import { Button } from '@/components/ui/button';

export function Topbar({ title }: { title: string }) {
  const { claims, logout, isAdvertiser } = useAuth();
  const [theme, setTheme] = useState<'light' | 'dark'>(storage.getTheme());

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    storage.setTheme(next);
    document.documentElement.classList.toggle('dark', next === 'dark');
  };

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b bg-card px-4 md:px-6">
      <h1 className="text-base font-semibold">{title}</h1>
      <div className="flex items-center gap-2">
        <span className="hidden items-center gap-1.5 rounded-full bg-muted px-3 py-1 text-xs text-muted-foreground sm:inline-flex">
          <User className="h-3.5 w-3.5" />
          {claims?.name || claims?.username || 'User'} · {isAdvertiser ? 'Advertiser' : claims?.role || 'Team'}
        </span>
        <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
        <Button variant="ghost" size="sm" onClick={logout}>
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sign out</span>
        </Button>
      </div>
    </header>
  );
}
